// extracted by mini-css-extract-plugin
module.exports = {"visibleOnHover":"KiosksTable_visibleOnHover__3ONcb","statusWrap":"KiosksTable_statusWrap__2J5s4","dot":"KiosksTable_dot__1VQwU"};